import React from 'react';
import styled from 'styled-components';
import {useTranslations} from "use-intl";

import ResetButton from '@/components/Button/ResetButton';
import { colors } from '@/constants/theme';
import { ReactComponent as CloseIcon } from '@/assets/svg/Modals/close.svg';

type Props = {
  onReset: () => void;
  closeModal: () => void;
};

function Header({ closeModal, onReset }: Props) {
  const t = useTranslations();

  return (
    <Component>
      <ResetButton label={t('filter.reset')} onClick={onReset} />
      <Title>{t('filter.title')}</Title>
      <StyledIcon onClick={closeModal} />
    </Component>
  );
}

export default Header;

const Component = styled.div`
  z-index: 5;
  position: sticky;
  top: 0;
  height: 45px;
  padding: 5px 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 1px 6px 0 #d0d0d0;
  background: ${colors.white};
`;

const Title = styled.div`
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 24px;
`;

const StyledIcon = styled(CloseIcon)`
  position: absolute;
  top: 50%;
  right: 15px;
  transform: translateY(-50%);
  cursor: pointer;
  margin-left: 15px;
`;
